import validate from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45trailing_45slash_45global from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/middleware/redirect-trailing-slash.global.ts";
import manifest_45route_45rule from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/middleware/auth.ts"),
  "category-validation": () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/middleware/category-validation.ts")
}